export enum Type {
    INT = 'int',
    FLOAT = 'float',
    BOOL = 'bool',
    STR = 'str',
    NONE = 'NoneType',
    NULL = 'null',
    UNKNOWN = 'unknown'
}

export type Primitive = string | number | boolean | Date;
